<div class="main-container" [class.selected-tooth]="selected" [attr.data-cy]="'perio-tooth-' + tooth.ToothId + '-container'">

  <!--<div class="tooth-label" *ngIf="displayToothId">
    {{ displayTooth.tooth | number  }}
  </div>-->
  <!--<div class="tooth-label" *ngIf="!displayToothId">

  </div>-->
  <input type="text"
         *ngIf="(facing === 'lingual' && section==='upper') || (facing === 'buccal' && section==='lower')"
         [id]="tooth.ToothId"
         (blur)="onValueChange();"
         [(ngModel)]="tooth.ToothComment"
         class="flex-item input-field 'input-onfocus"
         style="width: 100%"
         [attr.data-cy]="'perio-tooth-' + tooth.ToothId + '-comment-input'">
  <img *ngIf="!tooth.ToothIsImplant" [src]="toothImageSrc" [class.missing-tooth]="tooth.ToothIsMissing" [attr.data-cy]="'perio-tooth-' + tooth.ToothId + '-image'" />
  <img *ngIf="tooth.ToothIsImplant" [src]="toothImageSrcImplant" [class.missing-tooth]="tooth.ToothIsMissing" [attr.data-cy]="'perio-tooth-' + tooth.ToothId + '-implant-image'" />


  <!--<svg class="covering-canvas" *ngIf="facing === 'buccal' && section === 'upper'">
    <polyline points="00,105,68,105"
              style="fill:none;stroke:black;stroke-width:1" />
  </svg>

  <svg class="covering-canvas" *ngIf="facing === 'lingual' && section === 'upper'">
    <polyline points="00,75,68,75"
              style="fill:none;stroke:black;stroke-width:1" />
  </svg>

  <svg class="covering-canvas" *ngIf="facing === 'lingual' && section === 'lower'">
    <polyline points="00,105,68,105"
              style="fill:none;stroke:black;stroke-width:1" />
  </svg>

  <svg class="covering-canvas" *ngIf="facing === 'buccal' && section === 'lower'">
    <polyline points="00,75,68,75"
              style="fill:none;stroke:black;stroke-width:1" />
  </svg>-->

</div>
